import React from "react";
import { observer } from "mobx-react";
import { CircularProgress, Box } from "@mui/material";
import TerminView from "./TerminView";
import { TerminViewConstants } from "../TerminView";
import {
  AppointmentDto,
} from "../../../api-client";
import { useServiceAppointmentsByPatient } from "../../../stores/Appointment/appointment.queries";

interface ServicesTerminViewProps {
  patientId: number;
  dataRefreshFlag?: any;
  setDataRefreshFlag?: any;
  isView?: TerminViewConstants;
  isContinuous?: boolean;
  setUnScheduledSelectedAppointmentId?: any;
  setDeleteEvent?: any;
  includeAllAppointments?: boolean;
  isSelectionMode?: boolean;
  selectedAppointments?: string[];
  setSelectedAppointments?: React.Dispatch<React.SetStateAction<string[]>>;
  inActiveCount?: number | null;
}

const ServicesTerminView: React.FC<ServicesTerminViewProps> = observer(
  ({
    patientId,
    dataRefreshFlag,
    setDataRefreshFlag,
    isView = TerminViewConstants.RX_VIEW,
    isContinuous,
    setUnScheduledSelectedAppointmentId,
    setDeleteEvent,
    includeAllAppointments,
    isSelectionMode,
    selectedAppointments,
    setSelectedAppointments,
    inActiveCount,
  }) => {
    // TODO: Replace this placeholder with actual React Query hook when endpoint is available
    
    const { data: serviceAppointments = [], isLoading, error } = useServiceAppointmentsByPatient(patientId);
    
    // TODO: Uncomment when actual hook is implemented
    // if (isLoading) {
    //   return (
    //     <Box display="flex" justifyContent="center" alignItems="center" p={3}>
    //       <CircularProgress />
    //     </Box>
    //   );
    // }

    // if (error) {
    //   return (
    //     <Box p={2}>
    //       <span>Fehler beim Laden der Service-Termine für Patient {patientId}</span>
    //     </Box>
    //   );
    // }

    // Placeholder message until endpoint is implemented
    if (serviceAppointments.length === 0) {
      return (
        <Box p={2} textAlign="center">
          <span>...</span>
        </Box>
      );
    }

    return (
      <TerminView
        appointments={serviceAppointments}
        patientId={patientId}
        appointmentsLoading={isLoading}
        isView={isView}
        isContinuous={isContinuous}
        setUnScheduledSelectedAppointmentId={setUnScheduledSelectedAppointmentId}
        setDeleteEvent={setDeleteEvent}
        includeAllAppointments={includeAllAppointments}
        isSelectionMode={isSelectionMode}
        selectedAppointments={selectedAppointments}
        setSelectedAppointments={setSelectedAppointments}
        inActiveCount={inActiveCount}
      />
    );
  }
);

export default ServicesTerminView;
